/**
 * This file is the global include file. It is included on every page
 * in the front end.
 *
 * Include other files via `import` below.
 */

// Deps
import jQuery from 'jquery';
import objectFitImages from 'object-fit-images';

objectFitImages();

// Site / Global
//import sitePrimaryMenu from './src/_site_primary-menu';
import siteSearch from './src/_site_search';
import siteTools from './src/_site_tools';
import { siteSVGs } from './src/_site_svgs';
import { siteHelper } from './src/_site_helper';

// Components
import heroesSwiper from './src/_heroes-swiper';
import tweetsSwiper from './src/_tweets-swiper';
import anchors from './src/_anchors';
import collapseSlider from './src/_collapse-slider';
import videoSlider from './src/_video-slider';
import videoCarousel from './src/_video-carousel';
import  header  from './src/_header';
import preload from './src/_preload';
import languageMenu from './src/_language-menu';
import { newsFilterInit } from './src/_component_news-filter';
import { tweetsCarouselInit } from './src/_component_tweets';
import remodal from './src/components/remodal';
import { geolocationInit } from './src/_geolocation';
import { ketchPreferencesInit } from './src/_ketch-preferences';

// Window load
import { anchorsInit } from './src/_site_anchors';

//Preload
preload.init();
languageMenu.init();
ketchPreferencesInit();

jQuery( window ).on( 'load', function() {
	siteSearch.init();
	siteTools.init();
	siteSVGs();
	siteHelper();

	header.init();
	heroesSwiper.init();
	collapseSlider.init();
	tweetsSwiper.init();
	videoSlider.init();
	videoCarousel.init();
	newsFilterInit();
	tweetsCarouselInit();
	remodal( window, jQuery );

	anchorsInit();
	anchors();
	geolocationInit();
});
